export default "__VITE_ASSET__BpoTrFbk__"